
















import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import CategoryBase from './CategoryBase'
import CategoryForm from '@/components/CategoryForm.vue'
import Loader from '@/components/Loader.vue'
import { Category } from '@/models/Category'

@Component({
	components: {
		CategoryForm,
		Loader,
	},
})
export default class NewCategory extends CategoryBase {

	private submit(category: Category) {
		this.$store.dispatch('saveCategory', category).then(() => {
			this.$toasted.success('Category successfully created.')
			this.$router.push({ name: 'categories' })
		}, (error: any) => this.$toasted.error(`Error: ${category.errorArray}`))
	}
}
